import { z } from 'zod'

export const GetBalenaDeviceVariablesSchema = z.object({
    device_uuid: z.string()
})

export type GetBalenaDeviceVariables = z.infer<typeof GetBalenaDeviceVariablesSchema>

// Balena's device payload has many more keys; we only model the ones the app reads.
// `.passthrough()` keeps the rest in the inferred type without forcing us to enumerate them.
const BalenaReleaseRefSchema = z
    .object({
        __id: z.number().nullish()
    })
    .passthrough()

const BalenaDeviceRowSchema = z
    .object({
        api_heartbeat_state: z.string().nullish(),
        is_connected_to_vpn: z.boolean().nullish(),
        is_online: z.boolean().nullish(),
        is_running__release: BalenaReleaseRefSchema.nullish(),
        should_be_running__release: BalenaReleaseRefSchema.nullish(),
        should_be_operated_by__release: BalenaReleaseRefSchema.nullish(),
        last_connectivity_event: z.string().nullish(),
        last_vpn_event: z.string().nullish(),
        status: z.string().nullish(),
        supervisor_version: z.string().nullish(),
        update_status: z.string().nullish()
    })
    .passthrough()

export const GetBalenaDeviceQuerySchema = z.object({
    devices: z.array(BalenaDeviceRowSchema).nullish()
})

export type GetBalenaDeviceQuery = z.infer<typeof GetBalenaDeviceQuerySchema>

export const GetBalenaReleaseVariablesSchema = z.object({
    release_id: z.string()
})

export type GetBalenaReleaseVariables = z.infer<typeof GetBalenaReleaseVariablesSchema>

// We only model the fields we actually read; the upstream Balena payload has many more.
// `.passthrough()` keeps the rest of the keys in the inferred type without forcing us to enumerate them.
const BalenaReleaseRowSchema = z
    .object({
        commit: z.string().nullish(),
        semver: z.string().nullish()
    })
    .passthrough()

export const GetBalenaReleaseQuerySchema = z.object({
    releases: z.array(BalenaReleaseRowSchema).nullish()
})

export type GetBalenaReleaseQuery = z.infer<typeof GetBalenaReleaseQuerySchema>
